import { Component } from '@angular/core';

@Component({
    selector: 'ng-actions-table-bar',
    templateUrl: './actions-table-bar.component.html',
    styleUrls:['./actions-table-bar.component.css']
})

export class ActionTableBarComponent {}